import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-74c9dde4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "exhibition-gallery" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top-line" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "title" }, [
    /*#__PURE__*/_createTextVNode(" #Throwback To "),
    /*#__PURE__*/_createElementVNode("span", { class: "color" }, "Exhibitions")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "title-text" }, " Some memories from our latest exhibitions all over the world! ")
], -1))
const _hoisted_4 = { class: "images" }
const _hoisted_5 = ["src", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GalleryBox = _resolveComponent("GalleryBox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (image, index) => {
          return (_openBlock(), _createElementBlock("img", {
            key: image.thumb,
            src: require(`@/assets/img/${image.thumb}`),
            onClick: ($event: any) => (_ctx.imageIndex = index)
          }, null, 8, _hoisted_5))
        }), 128))
      ])
    ]),
    _createVNode(_component_GalleryBox, {
      class: "images",
      startWithIndex: _ctx.imageIndex,
      images: _ctx.images,
      onClear: _cache[0] || (_cache[0] = ($event: any) => (_ctx.imageIndex = null))
    }, null, 8, ["startWithIndex", "images"])
  ]))
}